// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   PREMIUM HERO – FULL CSS
================================== */

.kp-hero {
  background: #425151;
  min-height: 100vh;                 /* full screen on desktop */
  display: flex;
  flex-direction: column;
  justify-content: center;           /* center vertically */
  padding: 40px 20px 50px;
  color: white;
  font-family: "Inter", sans-serif;
  text-align: center;
}

/* TITLE */
.kp-title {
  font-size: 2.1rem;
  color: #FFE600;
  margin-bottom: 5px;
  font-weight: 500;
  margin-top: 30px;
  letter-spacing: -0.4px;
}

/* MAIN WRAPPER */
.kp-frame-wrapper {
  max-width: 1500px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.7fr 1fr;  /* more space for bullets */
  gap: 36px;
  align-items: center;
}


/* ===============================
   BULLET GRID / CARDS
================================== */

.kp-bullets {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px 28px;
  width: 100%;
}

.kp-point {
  display: flex;
  gap: 15px;
  align-items: flex-start;
  padding: 15px 22px;
  border-radius: 16px;
  /* background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px); */
  /* box-shadow: 0 10px 22px rgba(0, 0, 0, 0.25); */
  text-align: left;
  transition: 0.3s ease;
  min-height: 110px; 
}

.kp-point:hover {
  transform: translateY(-4px);
  background: rgba(255, 255, 255, 0.14);
}

/* Icon container */
.kp-iconWrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.20);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.25);
}

.kp-icon {
  width: 28px;
  height: 28px;
}

/* Card text */
.kp-point p {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.5;
  font-weight: 400;
  min-height: fit-content;
  min-width: fit-content;
  max-width: 660px;
  text-wrap: balance; 
}


/* ===============================
   RIGHT IMAGE
================================== */

.kp-frame-right {
  display: flex;
  justify-content: center;
}

.kp-frame-right img {
  width: 100%;
  max-width: 390px;                   /* controlled for 1-screen fit */
  height: auto;
  border-radius: 22px;
  margin-top: 10px;
  object-fit: cover;
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.32);
}


/* ===============================
   BOTTOM TEXT + BUTTONS
================================== */

.kp-bottom-text {
  margin-top: 22px;
  font-size: 1.35rem;
  color: #FFE600;
  font-weight: 400;
}

.kp-buttons {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  gap: 18px;
}

/* CTA Buttons base */
.kp-btn-outline,
.kp-btn-primary {
  padding: 14px 32px;
  border-radius: 11px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: 0.25s ease;
  border: 2px solid white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Outline button */
.kp-btn-outline {
  color: white;
  background: transparent;
}

.kp-btn-outline:hover {
  background: rgba(255, 255, 255, 0.18);
}

/* Primary button */
.kp-btn-primary {
  background: #FFE600;
  color: #425151;
  border-color: #FFE600;
  box-shadow: 0 8px 18px rgba(255, 230, 0, 0.35);
}

.kp-btn-primary:hover {
  background: #ffdd00;
}


/* ===============================
   RESPONSIVE BREAKPOINTS
================================== */

/* TABLET */
@media (max-width: 1024px) {

  .kp-hero {
    padding-top: 50px;
    padding-bottom: 60px;
    min-height: auto;                 /* allow scrolling on tablet */
  }

  .kp-frame-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }

  .kp-bullets {
    grid-template-columns: repeat(2, 1fr);
  }

  .kp-frame-right img {
    max-width: 70%;
  }
}

/* MOBILE */
@media (max-width: 650px) {

  .kp-hero {
    padding-top: 40px;
    padding-bottom: 50px;
  }

  .kp-title {
    font-size: 1.7rem;
    margin-bottom: 30px;
    margin-top: 70px;
  }

  .kp-bullets {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .kp-point {
    padding: 16px 18px;
    min-height: auto;
  }

  .kp-iconWrap {
    width: 46px;
    height: 46px;
  }

  .kp-icon {
    width: 22px;
    height: 22px;
  }

  .kp-point p {
    font-size: 1rem;
    max-width: 100%;
  }

  .kp-frame-right img {
    max-width: 100%;
  }

  .kp-buttons {
    flex-direction: column;
  }

  .kp-btn-outline,
  .kp-btn-primary {
    width: 100%;
  }
   .kp-metrics {
    flex-direction: column;
    gap: 22px;
  }

  .kp-m-metric-divider {
    display: none;
  }
}
/* ===============================
   METRICS BAR (Bottom KPI Strip)
================================== */

/* .kp-metrics {
  margin-top: 20px;
  width: 100%;
  background: #2f3b3c;
  padding: 18px 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 6px;
  max-width: 1300px;
  max-height: 80px;
  flex-direction: row;
  margin-left: auto;
  margin-right: auto;
  flex-wrap: nowrap;
} */

.kp-metrics {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 40px;
  background: #2f3b3c;
  /* height: 90px; */
  margin: 30px auto;
  flex-wrap: nowrap;
  padding: 10px 10px;
}

.kp-metric {
  text-align: center;
  padding: 0 25px;
}

.kp-m-num {
  font-size: 1.7rem;
  font-weight: 600;
  color: #FFE600;
}

.kp-m-label {
  font-size: 0.95rem;
  margin-top: 6px;
  opacity: 0.9;
  color: white;
}

/* Vertical divider */
.kp-m-metric-divider {
  height: 42px;
  width: 1px;
  background: rgba(255,255,255,0.25);
}

/* RESPONSIVE */
@media(max-width: 768px) {
  .kp-metrics {
    flex-direction: column;
    gap: 22px;
  }

   .kp-m-metric-divider {
    width: 80%;
    height: 1px;      /* horizontal line */
    margin: 0 auto;
  }

  .kp-m-num {
    font-size: 28px;
  }

  .kp-m-label {
    font-size: 14px;
  }
}
/* ======================================
   LARGE DESKTOP & 4K SCREENS 
   (Big monitors, iMac, 1440px – 2560px)
====================================== */

@media (min-width: 1440px) {

  .kp-hero {
    padding: 70px 40px 80px;
  }

  .kp-title {
    font-size: 2.6rem;
    letter-spacing: -0.5px;
    margin-bottom: 25px;
  }

  .kp-frame-wrapper {
    max-width: 1600px;
    grid-template-columns: 2fr 1.1fr;
    gap: 60px;
  }

  /* Bigger bullet cards */
  .kp-point {
    padding: 22px 28px;
    min-height: 135px;
  }

  .kp-point p {
    font-size: 1.25rem;
    line-height: 1.6;
  }

  /* Bigger icons */
  .kp-iconWrap {
    width: 60px;
    height: 60px;
  }

  .kp-icon {
    width: 32px;
    height: 32px;
  }

  /* Larger image on right */
  .kp-frame-right img {
    max-width: 480px;
    box-shadow: 0 22px 40px rgba(0,0,0,0.35);
  }

  .kp-bottom-text {
    font-size: 1.6rem;
    margin-top: 35px;
  }

  /* CTA Buttons */
  .kp-btn-outline,
  .kp-btn-primary {
    font-size: 1.1rem;
    padding: 16px 38px;
  }

  /* Bigger metrics bar */
  .kp-metrics {
    max-width: 1500px;
    padding: 20px 30px;
    gap: 60px;
  }

  .kp-m-num {
    font-size: 2.4rem;
  }

  .kp-m-label {
    font-size: 1.15rem;
  }

  .kp-m-metric {
    padding: 0 40px;
  }

  .kp-m-metric-divider {
    height: 55px;
  }
}


/* ======================================
   ULTRA-WIDE (2560px / 4K)
====================================== */

@media (min-width: 1920px) {

  .kp-title {
    font-size: 3rem;
  }

  .kp-frame-wrapper {
    max-width: 1900px;
    gap: 80px;
  }

  .kp-point {
    padding: 28px 32px;
    min-height: 150px;
  }

  .kp-frame-right img {
    max-width: 550px;
  }

  .kp-metrics {
    max-width: 1800px;
    gap: 90px;
  }

  .kp-m-num {
    font-size: 2.8rem;
  }

  .kp-m-label {
    font-size: 1.3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME/SECTIONS/SCREENING/index.css"],"names":[],"mappings":"AAAA;;oCAEoC;;AAEpC;EACE,mBAAmB;EACnB,iBAAiB,kBAAkB,2BAA2B;EAC9D,aAAa;EACb,sBAAsB;EACtB,uBAAuB,YAAY,sBAAsB;EACzD,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gCAAgC,GAAG,2BAA2B;EAC9D,SAAS;EACT,mBAAmB;AACrB;;;AAGA;;oCAEoC;;AAEpC;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB;gCAC8B;EAC9B,iDAAiD;EACjD,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,cAAc;AACd;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;;oCAEoC;;AAEpC;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB,oBAAoB,gCAAgC;EACpE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;;AAGA;;oCAEoC;;AAEpC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA,qBAAqB;AACrB;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;oCAEoC;;AAEpC,WAAW;AACX;;EAEE;IACE,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB,kBAAkB,8BAA8B;EAClE;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,WAAW;AACX;;EAEE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;GACC;IACC,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;AACA;;oCAEoC;;AAEpC;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,UAAU;EACV,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;GAEC;IACC,UAAU;IACV,WAAW,OAAO,oBAAoB;IACtC,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;;;wCAGwC;;AAExC;;EAEE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,SAAS;EACX;;EAEA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,uBAAuB;EACvB;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;;AAGA;;wCAEwC;;AAExC;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ===============================\n   PREMIUM HERO – FULL CSS\n================================== */\n\n.kp-hero {\n  background: #425151;\n  min-height: 100vh;                 /* full screen on desktop */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;           /* center vertically */\n  padding: 40px 20px 50px;\n  color: white;\n  font-family: \"Inter\", sans-serif;\n  text-align: center;\n}\n\n/* TITLE */\n.kp-title {\n  font-size: 2.1rem;\n  color: #FFE600;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-top: 30px;\n  letter-spacing: -0.4px;\n}\n\n/* MAIN WRAPPER */\n.kp-frame-wrapper {\n  max-width: 1500px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1.7fr 1fr;  /* more space for bullets */\n  gap: 36px;\n  align-items: center;\n}\n\n\n/* ===============================\n   BULLET GRID / CARDS\n================================== */\n\n.kp-bullets {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1px 28px;\n  width: 100%;\n}\n\n.kp-point {\n  display: flex;\n  gap: 15px;\n  align-items: flex-start;\n  padding: 15px 22px;\n  border-radius: 16px;\n  /* background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(10px); */\n  /* box-shadow: 0 10px 22px rgba(0, 0, 0, 0.25); */\n  text-align: left;\n  transition: 0.3s ease;\n  min-height: 110px; \n}\n\n.kp-point:hover {\n  transform: translateY(-4px);\n  background: rgba(255, 255, 255, 0.14);\n}\n\n/* Icon container */\n.kp-iconWrap {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.20);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.25);\n}\n\n.kp-icon {\n  width: 28px;\n  height: 28px;\n}\n\n/* Card text */\n.kp-point p {\n  margin: 0;\n  font-size: 1.1rem;\n  line-height: 1.5;\n  font-weight: 400;\n  min-height: fit-content;\n  min-width: fit-content;\n  max-width: 660px;\n  text-wrap: balance; \n}\n\n\n/* ===============================\n   RIGHT IMAGE\n================================== */\n\n.kp-frame-right {\n  display: flex;\n  justify-content: center;\n}\n\n.kp-frame-right img {\n  width: 100%;\n  max-width: 390px;                   /* controlled for 1-screen fit */\n  height: auto;\n  border-radius: 22px;\n  margin-top: 10px;\n  object-fit: cover;\n  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.32);\n}\n\n\n/* ===============================\n   BOTTOM TEXT + BUTTONS\n================================== */\n\n.kp-bottom-text {\n  margin-top: 22px;\n  font-size: 1.35rem;\n  color: #FFE600;\n  font-weight: 400;\n}\n\n.kp-buttons {\n  margin-top: 18px;\n  display: flex;\n  justify-content: center;\n  gap: 18px;\n}\n\n/* CTA Buttons base */\n.kp-btn-outline,\n.kp-btn-primary {\n  padding: 14px 32px;\n  border-radius: 11px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: 0.25s ease;\n  border: 2px solid white;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Outline button */\n.kp-btn-outline {\n  color: white;\n  background: transparent;\n}\n\n.kp-btn-outline:hover {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n/* Primary button */\n.kp-btn-primary {\n  background: #FFE600;\n  color: #425151;\n  border-color: #FFE600;\n  box-shadow: 0 8px 18px rgba(255, 230, 0, 0.35);\n}\n\n.kp-btn-primary:hover {\n  background: #ffdd00;\n}\n\n\n/* ===============================\n   RESPONSIVE BREAKPOINTS\n================================== */\n\n/* TABLET */\n@media (max-width: 1024px) {\n\n  .kp-hero {\n    padding-top: 50px;\n    padding-bottom: 60px;\n    min-height: auto;                 /* allow scrolling on tablet */\n  }\n\n  .kp-frame-wrapper {\n    grid-template-columns: 1fr;\n    gap: 40px;\n    text-align: center;\n  }\n\n  .kp-bullets {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .kp-frame-right img {\n    max-width: 70%;\n  }\n}\n\n/* MOBILE */\n@media (max-width: 650px) {\n\n  .kp-hero {\n    padding-top: 40px;\n    padding-bottom: 50px;\n  }\n\n  .kp-title {\n    font-size: 1.7rem;\n    margin-bottom: 30px;\n    margin-top: 70px;\n  }\n\n  .kp-bullets {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .kp-point {\n    padding: 16px 18px;\n    min-height: auto;\n  }\n\n  .kp-iconWrap {\n    width: 46px;\n    height: 46px;\n  }\n\n  .kp-icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  .kp-point p {\n    font-size: 1rem;\n    max-width: 100%;\n  }\n\n  .kp-frame-right img {\n    max-width: 100%;\n  }\n\n  .kp-buttons {\n    flex-direction: column;\n  }\n\n  .kp-btn-outline,\n  .kp-btn-primary {\n    width: 100%;\n  }\n   .kp-metrics {\n    flex-direction: column;\n    gap: 22px;\n  }\n\n  .kp-m-metric-divider {\n    display: none;\n  }\n}\n/* ===============================\n   METRICS BAR (Bottom KPI Strip)\n================================== */\n\n/* .kp-metrics {\n  margin-top: 20px;\n  width: 100%;\n  background: #2f3b3c;\n  padding: 18px 10px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  border-radius: 6px;\n  max-width: 1300px;\n  max-height: 80px;\n  flex-direction: row;\n  margin-left: auto;\n  margin-right: auto;\n  flex-wrap: nowrap;\n} */\n\n.kp-metrics {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 40px;\n  background: #2f3b3c;\n  /* height: 90px; */\n  margin: 30px auto;\n  flex-wrap: nowrap;\n  padding: 10px 10px;\n}\n\n.kp-metric {\n  text-align: center;\n  padding: 0 25px;\n}\n\n.kp-m-num {\n  font-size: 1.7rem;\n  font-weight: 600;\n  color: #FFE600;\n}\n\n.kp-m-label {\n  font-size: 0.95rem;\n  margin-top: 6px;\n  opacity: 0.9;\n  color: white;\n}\n\n/* Vertical divider */\n.kp-m-metric-divider {\n  height: 42px;\n  width: 1px;\n  background: rgba(255,255,255,0.25);\n}\n\n/* RESPONSIVE */\n@media(max-width: 768px) {\n  .kp-metrics {\n    flex-direction: column;\n    gap: 22px;\n  }\n\n   .kp-m-metric-divider {\n    width: 80%;\n    height: 1px;      /* horizontal line */\n    margin: 0 auto;\n  }\n\n  .kp-m-num {\n    font-size: 28px;\n  }\n\n  .kp-m-label {\n    font-size: 14px;\n  }\n}\n/* ======================================\n   LARGE DESKTOP & 4K SCREENS \n   (Big monitors, iMac, 1440px – 2560px)\n====================================== */\n\n@media (min-width: 1440px) {\n\n  .kp-hero {\n    padding: 70px 40px 80px;\n  }\n\n  .kp-title {\n    font-size: 2.6rem;\n    letter-spacing: -0.5px;\n    margin-bottom: 25px;\n  }\n\n  .kp-frame-wrapper {\n    max-width: 1600px;\n    grid-template-columns: 2fr 1.1fr;\n    gap: 60px;\n  }\n\n  /* Bigger bullet cards */\n  .kp-point {\n    padding: 22px 28px;\n    min-height: 135px;\n  }\n\n  .kp-point p {\n    font-size: 1.25rem;\n    line-height: 1.6;\n  }\n\n  /* Bigger icons */\n  .kp-iconWrap {\n    width: 60px;\n    height: 60px;\n  }\n\n  .kp-icon {\n    width: 32px;\n    height: 32px;\n  }\n\n  /* Larger image on right */\n  .kp-frame-right img {\n    max-width: 480px;\n    box-shadow: 0 22px 40px rgba(0,0,0,0.35);\n  }\n\n  .kp-bottom-text {\n    font-size: 1.6rem;\n    margin-top: 35px;\n  }\n\n  /* CTA Buttons */\n  .kp-btn-outline,\n  .kp-btn-primary {\n    font-size: 1.1rem;\n    padding: 16px 38px;\n  }\n\n  /* Bigger metrics bar */\n  .kp-metrics {\n    max-width: 1500px;\n    padding: 20px 30px;\n    gap: 60px;\n  }\n\n  .kp-m-num {\n    font-size: 2.4rem;\n  }\n\n  .kp-m-label {\n    font-size: 1.15rem;\n  }\n\n  .kp-m-metric {\n    padding: 0 40px;\n  }\n\n  .kp-m-metric-divider {\n    height: 55px;\n  }\n}\n\n\n/* ======================================\n   ULTRA-WIDE (2560px / 4K)\n====================================== */\n\n@media (min-width: 1920px) {\n\n  .kp-title {\n    font-size: 3rem;\n  }\n\n  .kp-frame-wrapper {\n    max-width: 1900px;\n    gap: 80px;\n  }\n\n  .kp-point {\n    padding: 28px 32px;\n    min-height: 150px;\n  }\n\n  .kp-frame-right img {\n    max-width: 550px;\n  }\n\n  .kp-metrics {\n    max-width: 1800px;\n    gap: 90px;\n  }\n\n  .kp-m-num {\n    font-size: 2.8rem;\n  }\n\n  .kp-m-label {\n    font-size: 1.3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
